
<div class="amplify-greeting" *ngIf="signedIn">
    <div class="amplify-greeting-text">{{ greeting }}</div>
    <div class="amplify-greeting-flex-spacer"></div>
    <a class="amplify-form-link amplify-greeting-sign-out"
      (click)="onSignOut()"
      data-test="sign-out-button"
    >{{ this.amplifyService.i18n().get('Sign Out') }}</a>
</div>



// WEBPACK FOOTER //
// ./node_modules/aws-amplify-angular/dist/src/components/authenticator/greeting-component/greeting.component.core.d.ts.GreetingComponentCore.html